import urlParse from 'url-parse';

const state = () => ({
  loading: false,
  args: null,
  items: [],
  offset: 0,
  hits: 0,
  size: 0,
  total: 0,
});

const getters = {
  getLoading: (state) => state.loading,
  getItems: (state) => state.items,
  getOffset: (state) => state.offset,
  getHits: (state) => state.hits,
  getSize: (state) => state.size,
  getTotal: (state) => state.total,
  hasNext: (state) => state.offset + state.size < state.total,
}

const actions = {

  fetch({ commit }, url) {
    let args = urlParse(url, true);

    commit('loading', true);
    commit('args', args);
    commit('offset', parseInt(args.query.offset ? args.query.offset : 0, 10));
    commit('hits', parseInt(args.query.hits ? args.query.hits : 9, 10));

    return fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'text/plain',
          'Accept': 'application/json',
        }
      })
      .then(response => response.json())
      .then(response => {
        if (response) {
          commit('items', response.components);
          commit('size', response.size);
          commit('total', response.total);
        }
        commit('loading', false);
      });
  },

  next({ commit, dispatch, state }) {
    commit('loading', true);
    state.args.query.offset = state.offset + state.hits;
    return dispatch('fetch', state.args.toString());
  },
}

const mutations = {
  args: (state, value) => state.args = value,
  loading: (state, value) => state.loading = value,
  items: (state, value) => state.items = state.items.concat(value),
  hits: (state, value) => state.hits = value,
  offset: (state, value) => state.offset = value,
  size: (state, value) => state.size = value,
  total: (state, value) => state.total = value,
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}